import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Fun javascript feature",
  "description": "",
  "published": "2011-12-07T00:00:00.000Z",
  "redirect_from": ["/blog/fun-javascript-feature/swizec/3141"],
  "categories": "Algorithm, JavaScript, Languages, Non-deterministic Turing machine, Programming, Turing machine, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Not only was `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/nondeterministic-turing-machine-simulator-in-23-lines-of-javascript/swizec/3047",
        "title": "Nondeterministic turing machine simulator in 23 lines of JavaScript"
      }}>{`my nondeterministic turing machine implementation`}</a>{`way too long at 20 lines, it was also wrong. Shortly after `}<a parentName="p" {...{
        "href": "https://twitter.com/#!/dionyziz"
      }}>{`@dionyziz`}</a>{` reported a bug and it took me until last night to get around to fixing it.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/14310922_6ed3badf9e_m1.jpg",
        "alt": "class NP",
        "title": "class NP"
      }}></img></p>
    <p>{`The problem was that when I was passing tapes for each possible step into the next iteration of the algorithm the good old "everything is a reference" javascript feature bit me in the arse. Because of this all the tapes looked exactly like the tape belonging to the last state inspected and so when you moved the instructions around a bit you could make my implementation fail without actually changing the actual turing machine.`}</p>
    <p>{`Fixing it was a simple matter of strategically using underscore's clone function to make sure ever inspected state is acting on its own version of the tape.`}</p>
    <p>{`And since the fix was so simple and I didn't feel like studying the subject that has been the bane of my existence for the past two years, I decided to try codegolfing the algorithm a bit. Doing so I accidentally came upon what is possibly javascript's funnest feature.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var δ = function (S, s, e) {
  var π = _.keys,
    Θ = {},
    k,
    i,
    λ,
    μ,
    ι,
    Σ = _.size,
    β,
    ψ;
  if (π(s).indexOf(e) >= 0) return !0;
  for (k in s) {
    (i = s[k][0]), (λ = s[k][1]), (ψ = S[k][λ[i]] || S[k].B);
    for (ι = 0; ψ, ι < Σ(ψ); ) {
      (μ = ψ[ι++]),
        (β = _.clone(λ)),
        β.splice(i, 1, μ.w),
        (Θ[μ.n] = [i + μ.m, β]);
    }
  }
  return Σ(Θ) ? δ(S, Θ, e) : !!0;
};
`}</code></pre>
    <p>{`Glorious 252 characters of nondeterministic turing machine right there! I'd say 252 bytes, but it's not, look at all those shiny unicode characters!`}</p>
    <p>{`Turns out even though javascript legally only allows numbers, letters and the $ and `}{`_`}{` signs for variable names ... using almost any imaginable unicode character is also legal. Perhaps slightly difficult to type, but definitely a useful feature for making more expressive code.`}</p>
    <p>{`Especially when codegolfing or implementing physics or maths.`}</p>
    <p>{`Not sure I'll ever be using this again though ... oh and here's a slightly more readable version:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var δ = function (S, s, e) {
  var π = _.keys,
    Θ = {},
    k,
    i,
    λ,
    μ,
    ι,
    Σ = _.size,
    β,
    ψ;
  if (π(s).indexOf(e) >= 0) return !0;
  for (k in s) {
    (i = s[k][0]), (λ = s[k][1]), (ψ = S[k][λ[i]] || S[k].B);

    for (ι = 0; ψ, ι < Σ(ψ); ) {
      μ = ψ[ι++];
      β = _.clone(λ);
      β.splice(i, 1, μ.w);
      Θ[μ.n] = [i + μ.m, β];
    }
  }
  return Σ(Θ) ? δ(S, Θ, e) : !!0;
};
`}</code></pre>
    <p>{`Before you ask, `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/random-coding/blob/master/machine2.json"
      }}>{`machine instructions look like this`}</a>{` and you can find a script for running all of this over at `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/random-coding/blob/master/turing.js"
      }}>{`my github`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=f71ddb32-99a1-410b-9125-9664459b978b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      